import { render, staticRenderFns } from "./FoodPosDemo.vue?vue&type=template&id=90a2184a&scoped=true&"
import script from "./FoodPosDemo.vue?vue&type=script&lang=js&"
export * from "./FoodPosDemo.vue?vue&type=script&lang=js&"
import style0 from "./FoodPosDemo.vue?vue&type=style&index=0&id=90a2184a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a2184a",
  null
  
)

export default component.exports